import type { FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Resources from './components/Resources'
import Hero from './components/Hero'
import Overview from './components/Overview'
import ReadyData from './components/ReadyData'
import Predictive from './components/Predictive'
import Generative from './components/Generative'
import PersonalizationEngine from './components/PersonalizationEngine'

import ogImage from './assets/OgAI.png'

const AIView: FC = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="CustomerAI | Twilio Segment"
        pageDescription="Segment makes it easier than ever to understand, predict, generate, and engage each individual customer in real-time and at scale."
        pageOG={ogImage}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Main>
          <Hero />
          <Overview />
          <ReadyData />
          <Predictive />
          <Generative />
          <PersonalizationEngine />
          <Resources />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  overflow: hidden;
`

export default AIView
